import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  DEFAULT_LANGUAGES,
  ILanguage,
  LanguagePrefix,
  LanguageId,
} from '@web/dtos';
import {
  ILanguageForm,
  ILanguageFormDataWrapper,
  ILanguageFormWrapper,
} from '../../entities/language-entity';
import { Factory } from '../factory';

@Injectable({
  providedIn: 'root',
})
export class LanguageFormsFactoryService extends Factory<
  ILanguageFormWrapper,
  ILanguage[]
> {
  formBuilder: FormBuilder = inject(FormBuilder);

  buildForm(
    entity: ILanguage[] = DEFAULT_LANGUAGES
  ): FormGroup<ILanguageFormWrapper> {
    return this.formBuilder.group<ILanguageFormWrapper>({
      languages: this.formBuilder.array<FormGroup<ILanguageForm>>(
        entity.map((lang: ILanguage): FormGroup<ILanguageForm> => {
          return this.buildLanguageFormGroup(lang);
        })
      ),
    });
  }

  buildLanguageFormGroup(language: ILanguage): FormGroup<ILanguageForm> {
    return this.formBuilder.group<ILanguageForm>({
      id: this.formBuilder.control<LanguageId | null>(language?.id || null),
      name: this.formBuilder.nonNullable.control<string>(language?.name, [
        Validators.required,
      ]),
      prefix: this.formBuilder.nonNullable.control<LanguagePrefix>(
        language?.prefix,
        [Validators.required]
      ),
      isActive: this.formBuilder.nonNullable.control<boolean>(
        language?.isActive,
        [Validators.required]
      ),
      isStandard: this.formBuilder.nonNullable.control<boolean>(
        language?.isStandard,
        [Validators.required]
      ),
    });
  }

  buildEntity(forms: FormGroup<ILanguageFormWrapper>): ILanguage[] {
    const wrapper = forms.getRawValue() as ILanguageFormDataWrapper;

    const newLanguages: ILanguage[] = [];
    wrapper.languages.forEach((lang: ILanguage) => {
      const newLanguage: ILanguage = {
        ...lang,
      };
      this.removeNullIds(newLanguage);
      newLanguages.push(newLanguage);
    });
    return newLanguages as ILanguage[];
  }
}
